import { createSlice } from "@reduxjs/toolkit";
import { GetUserTypes } from "services/dropdown/dropdown.service";
import { toast } from 'react-toastify';

export const userTypeSlice = createSlice({
  name: "userTypes",
  initialState: {
    userTypeList: [],
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetUserTypes.pending, () => {
      // toast.success('Promise Pending 🤯');
    });

    builder.addCase(GetUserTypes.fulfilled, (state, action) => {
      state.userTypeList = action.payload
    });

    builder.addCase(GetUserTypes.rejected, () => {
      toast.dismiss();
      toast.error('Promise rejected 😣')

    });
  },
});

export default userTypeSlice.reducer;
